import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import { EUserSortField, IUser, PUserFilter } from "src/core/user/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IUserState {
  users: IUser[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IUserState = {
  users: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "user/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "user/FETCH_SUCCEEDED";
const FETCH_FAILED = "user/FETCH_FAILED";
const POLLING_START_REQUESTED = "user/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "user/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IUser[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PUserFilter;
    pagination: IPagination;
    sorts: ISort<EUserSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IUserState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IUserState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.users = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
